import { produce } from 'immer';

import { UpdateInternalBannersForEdit } from '../../../actions/bannersEdit/internal/updateInternalBannersForEdit';
import { PageStatus } from '../../../typings/common';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function updateInternalBannersForEdit(
    state: EditInternalBannersState,
    action: UpdateInternalBannersForEdit
): EditInternalBannersState {
    return produce(state, draft => {
        draft.pageStatus = PageStatus.LOADED;
        draft.banners = action.data.banners;
        draft.bannersServerValues = action.data.banners;
        draft.clientId = action.data.clientId;
        draft.groupBannersList = action.data.groupBannersList;
        draft.placeTemplates = action.placeTemplates;
        draft.templateResources = action.templateResources;
    });
}
